import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/styles";
import {
  TextField,
  Grid,
  CardHeader,
  Divider,
  Button,
  Fab,
  Typography,
  IconButton,
  CircularProgress,
} from "@material-ui/core";
import PhotoCamera from "@material-ui/icons/PhotoCamera";
import SaveIcon from "@material-ui/icons/Save";
import RTL from "../../../../components/RTL";
import province from "./../../../province";
import cars from "./../../../car";
import bars from "./../../../bar";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";
import jMoment from "moment-jalaali";
import JalaliUtils from "@date-io/jalaali";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import RemoveIcon from "@material-ui/icons/Remove";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { Loading, showSnackbar } from "redux/Action";
import { useDispatch, useSelector } from "react-redux";
import { axios } from "./../../../../axios";
jMoment.loadPersian({ dialect: "persian-modern", usePersianDigits: true });

const useStyles = makeStyles((theme) => ({
  imageContainer: {
    width: 140,
    height: 140,
    margin: "auto",
    position: "relative",
    overflow: "unset",
  },
  inputBtn: {
    marginTop: theme.spacing(3),
    width: "100%",
  },
  imageButton: {
    position: "absolute",
    left: -15,
    bottom: -10,
  },
  image: {
    width: 110,
    height: 110,
  },
  input: {
    marginTop: theme.spacing(4),
    width: "100%",
  },
  imageInput: {
    display: "none",
  },
  divider: {
    opacity: "0.1",
    marginLeft: "25%",
    marginRight: "25%",
    width: "50%",
    alignItems: "center",
    backgroundColor: "#273c75",
    height: 1,
  },
  submitButtonIcon: {
    marginLeft: theme.spacing(2),
  },
  wrapper: {
    position: "relative",
    width: "100%",
  },
  buttonProgress: {
    color: "#121E3E",
    position: "absolute",
    top: "50%",
    left: "50%",
    marginLeft: -12,
  },
}));

const Form = (props) => {
  const { data, id, edit, reloadFunc, onClose } = props;
  const [city, setCity] = useState("");
  const [bar, setBar] = useState("");
  const [car, setCar] = useState("");
  const [tonage, setTonage] = useState("");
  const [num, setNum] = useState("");

  const classes = useStyles();

  const [Allcities, setAllcities] = useState([]);
  const [AllTruck_types, setTruck_types] = useState([]);
  const [AllShipment_type, setShipment_type] = useState([]);
  const dispatch = useDispatch();
  const token = useSelector((state) => state.token);
  const isLoading = useSelector((state) => state.isLoading);

  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const [error, setError] = React.useState({
    dest_city_id: "",
    truck_model_id: "",
    shipment_type_id: "",
    tonnage: "",
    num: "",
  });

  const Get_Data_Sel = async () => {

    try {
      // const res = await axios.get(`requests/${id}`, {
      //   headers: headers,
      // });
      // setCity(
      //   res.data.shipment?.destination?.get_province?.name +
      //     " " +
      //     res.data.shipment?.destination?.name
      // );
      // setCar(
      //   res.data.shipment?.truck_model?.truck_type?.name +
      //     " " +
      //     res.data.shipment?.truck_model?.name
      // );
      // setBar(res.data.shipment?.shipment_type?.name);
      // setNum(res.data.shipment.num);
      // setTonage(
      //   res.data.shipment.tonnage == 0 ? "" : res.data.shipment.tonnage
      // );
      dispatch(Loading());
    } catch (e) {
      dispatch(Loading());
    }
  };

  const Get_Component = async () => {
    try {
      // const res = await axios.get('shipments/create', {
      //   headers: headers,
      // });
      // let dataCity=res.data.cities;

      // let final_City = [];
      // dataCity.forEach((obj, i) => {
      //   final_City = [
      //     ...final_City,
      //     {
      //       id: obj.id,
      //        province_id: obj.province_id,
      //         county_id: obj.county_id,
      //       name:obj.get_province?.name+" "+ obj.name
      //     },
      //   ];
      // });
      // setAllcities(final_City)

      // console.log("aaaaaaaaasdasd",final_City)

      // setTruck_types(res.data.truck_types)
      // setShipment_type(res.data.shipment_type)
      if (edit) {
        Get_Data_Sel();
        dispatch(Loading());
      }
      dispatch(Loading());
    } catch (e) {
      dispatch(Loading());
      console.log(e.response, "eeeeeeeee");
    }
  };

  useEffect(() => {
    Get_Component();
    dispatch(Loading());
  }, []);

  // const UpdateShipment = async () => {
  //   let citySel= Allcities.filter((dt) => dt.name == city)
  //   .map((filterData) => filterData);

  //   let shipment_typeSel= AllShipment_type.filter((dt) => dt.name == bar)
  //   .map((filterData) => filterData);

  //  let truck_typeSel= AllTruck_types.filter((dt) => dt.full_name == car)
  //  .map((filterData) => filterData)

  //   try{
  //     const res = await axios.post(`shipments/${id}`, {

  //       dest_city_id:citySel[0].id,
  //       shipment_type_id:shipment_typeSel[0].id,
  //       truck_model_id:truck_typeSel[0].id,
  //       tonnage:tonage,
  //       num:num,
  //       _method:'patch'
  //     },{
  //       headers:headers
  //     });
  //     dispatch(showSnackbar(true,'success','بار با موفقیت ویرایش شد'))

  //     reloadFunc();
  //     onClose()
  //      dispatch(Loading())

  //   }catch(e)
  //   {
  //     dispatch(Loading())
  //     console.log(e.response,"eeeeeeeee")
  //     if (e.response.status === 422)
  //     {
  //       const er = e.response.data.errors;

  //       let er_keys = Object.keys(er);
  //       let obj_error = {};
  //       er_keys.forEach((element) => {

  //         obj_error[element] = er[element][0];
  //       });

  //       setError(obj_error);
  //     }
  //   }

  // }

  // const sendBtn = () => {
  //   let obj_empty = {};

  //   if(city==="")
  //   {
  //     obj_empty['dest_city_id'] = "این فیلد نمی تواند خالی باشد";

  //   }
  //   // if(num==="")
  //   // {
  //   //   obj_empty['num'] = "این فیلد نمی تواند خالی باشد";
  //   // }
  //   // if(tonage==="")
  //   // {
  //   //   obj_empty['tonnage'] = "این فیلد نمی تواند خالی باشد";
  //   // }
  //   if(car==="")
  //   {
  //     obj_empty['truck_model_id'] = "این فیلد نمی تواند خالی باشد";
  //   }
  //   if(bar==="")
  //   {
  //     obj_empty['shipment_type_id'] = "این فیلد نمی تواند خالی باشد";
  //   }

  //   setError( obj_empty);

  //   if (Object.keys(obj_empty).length == 0) {
  //     if (edit) {
  //       dispatch(Loading());
  //       UpdateShipment()
  //     } else {
  //       // dispatch(Loading());
  //     //  InsertEmployee()
  //     // alert(JSON.stringify(inputFields))

  //     }
  //   }
  //   else
  //   {

  //   }
  // };

  return (
    <RTL>
      {!isLoading ? (
        <>
          {edit ? (
            <Grid justify="center" container>
              <CardHeader title="اطلاعات درخواست بار" />
              <Divider className={classes.divider} variant="fullWidth" />
            </Grid>
          ) : (
            ""
          )}

          {/* <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">

      <Grid container justify="space-between">
            <Grid style={{paddingLeft:15}} alignItems="flex-start" item xs={12} sm={6}>
               <DatePicker
                className={classes.input}
                inputVariant="outlined"
                okLabel="تأیید"
                cancelLabel="لغو"

                label="تاریخ ابلاغ قرارداد"
                labelFunc={(date) => (date ? date.format("jYYYY/jMM/jDD") : "")}
                value={selectedDate}
                onChange={handleDateChange}
              />
            </Grid>
           
            <Grid  item xs={12} sm={6}>
            <Autocomplete
                id="TypeContract"
                noOptionsText="همچنین شهری وجود ندارد"
                options={province}
                getOptionLabel={(option) => option.city}
                onChange={(event, value) =>
                  value !== null
                    ? ` ${setCity(value.city)} ${setProvince_city(value.province)}`
                    : ""
                }
               
                value={{
                  city: ` ${
                      city
                  }`
                }}

               
                renderInput={(params) => (
                  <TextField
                    className={classes.input}
                    {...params}
                    label="مبدا "
                    variant="outlined"
                    
                    
                  />
                )}
              />
              </Grid>

            </Grid>
            </MuiPickersUtilsProvider> */}
          <Grid>
            <Grid
              style={{ marginTop: 20 }}
              container
              justify="space-between"
              xs={12}
              sm={12}
            >
              <Grid item xs={12} sm={6}>
              
                <Typography display="inline" variant="h5" gutterBottom>
                  تاریخ درخواست بار :
                </Typography>
                <Typography
                  style={{ marginRight: 5 }}
                  variant="body2"
                  display="inline"
                  gutterBottom
                >
                  {id.data.date}

                  {/* {id} */}
                  {/* {props.data.contract_number} */}
                </Typography>
              </Grid>

              <Grid item xs={12} sm={5}>
              <Typography display="inline" variant="h5" gutterBottom>
                  نام درخواست کننده :
                </Typography>
                <Typography
                  style={{ marginRight: 5 }}
                  variant="body2"
                  display="inline"
                  gutterBottom
                >
                  {id.data.name}

                  {/* {filterData.date_start} */}
                  {/* {props.data.date_start} */}
                </Typography>
              </Grid>
            </Grid>

            <Grid
              style={{ marginTop: 20 }}
              container
              justify="space-between"
              xs={12}
              sm={12}
            >
              <Grid item xs={12} sm={6}>
                <Typography display="inline" variant="h5" gutterBottom>
                  شماره تماس :
                </Typography>
                <Typography
                  style={{ marginRight: 5 }}
                  variant="body2"
                  display="inline"
                  gutterBottom
                >
                  {id.data.phone}

                  {/* {id} */}
                  {/* {props.data.contract_number} */}
                </Typography>
              </Grid>

              <Grid item xs={12} sm={5}>
                <Typography display="inline" variant="h5" gutterBottom>
                  مسیر :
                </Typography>
                <Typography
                  style={{ marginRight: 5 }}
                  variant="body2"
                  display="inline"
                  gutterBottom
                >
                  {id.data.origin+"  >  "+id.data.dest}

                  {/* {filterData.date_start} */}
                  {/* {props.data.date_start} */}
                </Typography>
              </Grid>
            </Grid>

            <Grid
              style={{ marginTop: 20 }}
              container
              justify="space-between"
              xs={12}
              sm={12}
            >
              <Grid item xs={12} sm={6}>
                <Typography display="inline" variant="h5" gutterBottom>
                  نوع بار :
                </Typography>
                <Typography
                  style={{ marginRight: 5 }}
                  variant="body2"
                  display="inline"
                  gutterBottom
                >
                  {id.data.type_shipment}

                  {/* {id} */}
                  {/* {props.data.contract_number} */}
                </Typography>
              </Grid>

              <Grid item xs={12} sm={5}>
                <Typography display="inline" variant="h5" gutterBottom>
                  نوع ماشین :
                </Typography>
                <Typography
                  style={{ marginRight: 5 }}
                  variant="body2"
                  display="inline"
                  gutterBottom
                >
                  {id.data.type_car}

                  {/* {filterData.date_start} */}
                  {/* {props.data.date_start} */}
                </Typography>
              </Grid>
            </Grid>

            <Grid
              style={{ marginTop: 20 }}
              container
              justify="space-between"
              xs={12}
              sm={12}
            >
              <Grid item xs={12} sm={6}>
                <Typography display="inline" variant="h5" gutterBottom>
                  تناژ :
                </Typography>
                <Typography
                  style={{ marginRight: 5 }}
                  variant="body2"
                  display="inline"
                  gutterBottom
                >
                  {id.data.tonnage}

                  {/* {id} */}
                  {/* {props.data.contract_number} */}
                </Typography>
              </Grid>

              <Grid item xs={12} sm={5}>
                <Typography display="inline" variant="h5" gutterBottom>
                  توضیحات :
                </Typography>
                <Typography
                  style={{ marginRight: 5 }}
                  variant="body2"
                  display="inline"
                  gutterBottom
                >
                  {id.data.desc}

                  {/* {filterData.date_start} */}
                  {/* {props.data.date_start} */}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </>
      ) : (
        <div className={classes.wrapper} style={{ padding: 40 }}>
          {isLoading && (
            <CircularProgress size={24} className={classes.buttonProgress} />
          )}
        </div>
      )}
    </RTL>
  );
};

export default Form;
